import React, { useEffect, useState, useContext } from 'react';
import css from './SendBulkModal.module.css'
import { AppContext } from '../../../../providers/appProvider';
import Modal from '../../../UI/Modal/Modal';
import Comment from '../../../../assets/Icon/SmsIcon';
import { useTranslation } from 'react-i18next';
 

const SendBulkModal = ({ userService }) => {
  const {t} = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { appState, app } = useContext(AppContext);
  
  const [text, setText] = useState("");
 
  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleChangeButtonClick = () => {
    userService.bulkSms(text)
      .then((response) => {
        setIsModalOpen(false)
      })
      .catch((error) => {
        app.setError("შეცდომა")
      });
  };

  const openDelete = () => {
    setIsModalOpen(true)
  }

  const closeDelete = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
 
      <span onClick={() => openDelete()} className={css.btn}>
        <span className={css.icon} > <Comment /></span>
          Bulk SMS
      </span>

      <Modal  size="medium" isOpen={isModalOpen} onClose={() => closeDelete()}>
        <div>

          <div className={css.modalHead} >
            <h3>
              <span className={css.iconHead} > <Comment/></span>
              <div className={css.bulkTitle}>
                <div>Bulk SMS</div> 
                <div className={css.userCount}>{t('TheMessageWillBeSent')} <span>{userService.total}</span> </div> 
              </div>
            </h3>
          </div>

          <textarea
            placeholder={t('Message')}
            value={text}
            onChange={handleTextChange}
            rows="14"
            cols="55"
            className={css.customtextarea}
          ></textarea>
 
          <span onClick={handleChangeButtonClick} style={{ marginLeft: 'auto' }} className={css.btnPrimary}>{t('Sent')}</span>


        </div>
      </Modal>
    </div>
  );
};

export default SendBulkModal;